import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaQuestionCircle, FaSearch, FaStar, FaBookMedical } from 'react-icons/fa';
import './CommunitySearch.css';

const CommunitySearch = () => {
    const { t } = useTranslation();

    return (
        <section className="community-search">
            <div className="search-box-container">
                <div className="search-input-wrapper">
                    <FaQuestionCircle className="search-box-icon" />
                    <input
                        type="text"
                        placeholder={t('community.search.placeholder')}
                        className="search-input"
                    />
                    <button className="search-btn">
                        {t('community.search.btn')}
                    </button>
                </div>
            </div>

            <div className="results-container">
                <div className="results-header">
                    <FaStar className="ai-icon" />
                    <h2 className="results-title">{t('community.results.title')}</h2>
                </div>

                <div className="results-grid">
                    <div className="result-card">
                        <div className="card-header">
                            <span className="card-type">{t('community.results.study')}</span>
                            <span className="recommended-tag">{t('community.results.recommended')}</span>
                        </div>
                        <p className="card-desc">
                            Investigación sobre nuevos métodos de control glucémico no invasivo en fase III.
                        </p>
                        <a href="#" className="card-link">{t('community.results.apply')} &rarr;</a>
                    </div>

                    <div className="result-card">
                        <div className="card-header">
                            <span className="card-type">{t('community.results.glosary')}</span>
                        </div>
                        <p className="card-desc">
                            Un estudio de investigación realizado con participantes humanos para evaluar una intervención médica.
                        </p>
                        <a href="#" className="card-link">{t('community.results.learnMore')} &rarr;</a>
                    </div>
                </div>

                <div className="popular-tags">
                    <span className="popular-label">Popular:</span>
                    <span>Diabetes Tipo 2</span>
                    <span>Oncología</span>
                    <span>Salud Mental</span>
                </div>
            </div>
        </section>
    );
};

export default CommunitySearch;
